export default "__VITE_ASSET__DoYKT$g___"